import { gql } from '@apollo/client'

// The generic upload / deleteImage / uploadGolang documents were removed here: IAM
// authorizes on the GraphQL root field name and cannot read arguments, so those fields
// could carry no permission, were left unmapped, and returned 403 to everyone. Their
// per-entity replacements live in uploadPerEntity.ts.

export const PROVIDER_LOGO_QUERY = gql`
  query ProviderLogo($providerCode: String!) {
    providerLogo(providerCode: $providerCode) {
      url
      size
      name
      id
    }
  }
`

export const TENANT_LOGO_QUERY = gql`
  query TenantLogo($tenantCode: Int!) {
    tenantLogo(tenantCode: $tenantCode) {
      url
      size
      name
      id
    }
  }
`

export const ACCOMMODATION_LOGO_QUERY = gql`
  query AccommodationLogo($propertyCode: String!) {
    accommodationLogo(propertyCode: $propertyCode) {
      url
      size
      name
      id
    }
  }
`

export const ACCOMMODATION_IMAGES_QUERY = gql`
  query AccommodationImages($propertyCode: String!) {
    accommodationImages(propertyCode: $propertyCode) {
      url
      size
      name
      id
    }
  }
`

export const ACCOMMODATION_COVER_IMAGE_QUERY = gql`
  query AccommodationCoverImage($propertyCode: String!) {
    accommodationCoverImage(propertyCode: $propertyCode) {
      url
      size
      name
      id
    }
  }
`

export const ROOMTYPE_IMAGES_QUERY = gql`
  query RoomTypeImages($propertyCode: String!, $roomTypeCode: String!) {
    roomTypeImages(propertyCode: $propertyCode, roomTypeCode: $roomTypeCode) {
      url
      size
      name
      id
    }
  }
`

export const CHANNEL_LOGO_QUERY = gql`
  query ChannelLogo($channelCode: String!) {
    channelLogo(channelCode: $channelCode) {
      url
      size
      name
      id
    }
  }
`
